import { EdgeLoadLicenseCatalogRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { LoadLicenseCatalog } from '@/shared/domain'

export function makeLoadLicenseCatalog(): LoadLicenseCatalog {
  return new EdgeLoadLicenseCatalogRepository(makeSupabaseEdgeHttpClient()).execute
}
